module.exports = __webpack_public_path__ + "public/img/img_android_down_kr_2.8ad8070e.png";